import { TextOld } from '~/components/ui/text';
import { Title, TITLE_TYPE } from '~/components/ui/title';
import { COLORS } from '~/styles/colors';

import { StyledCard, StyledImage, StyledImageWrapper } from './styled';

const Card = ({ image, title, text }) => {
  return (
    <StyledCard>
      <StyledImageWrapper>
        <StyledImage src={image} alt={title} />
      </StyledImageWrapper>
      <Title type={TITLE_TYPE.h3} color="#292929">
        {title}
      </Title>
      <TextOld color={COLORS.grey400} fontSize={16} fontWeight={400}>
        {text}
      </TextOld>
    </StyledCard>
  );
};

export default Card;
